import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { hooks, log } from '@atlassian/mpac-utils';
import { useEffect } from 'react';
import { AppInstallPermissionEvaluationFailed } from '../../../../analytics/Events';
import { fetchMarketplaceAppData } from './utils';
const {
  usePromise
} = hooks;
export const useMarketplaceAppDetails = _ref => {
  let {
    appKey,
    fetchInstalledApp,
    contextId,
    deploymentType,
    marketplaceApp,
    flags,
    hostCmtEnabled
  } = _ref;
  const appPromiseFn = () => fetchMarketplaceAppData({
    appKey,
    fetchInstalledApp,
    contextId,
    deploymentType,
    marketplaceApp,
    flags,
    hostCmtEnabled
  });
  const {
    result,
    error,
    pending
  } = usePromise(appPromiseFn, [appKey, contextId, deploymentType, marketplaceApp], !!deploymentType);
  useEffect(() => {
    if (error) {
      log.error('DiscoverAppDetails', "failed to retrieve app listing details", {
        extraInfo: {
          appKey
        },
        error
      });
    }
  }, [error]);
  return {
    result,
    error,
    pending
  };
};
export const useInstallPermission = _ref2 => {
  let {
    appKey,
    isPermissionCheckNeeded,
    installPermissionResult
  } = _ref2;
  const installPermission = installPermissionResult ? installPermissionResult.fold(() => false, permissionCheck => permissionCheck.allowed) : false;
  const hasInstallPermission = !isPermissionCheckNeeded || installPermission;
  const permissionMessage = installPermissionResult === null || installPermissionResult === void 0 ? void 0 : installPermissionResult.fold(error => error, permissionCheck => permissionCheck.message || null);
  const fireAnalyticsEvent = useAnalyticsEvents();
  useEffect(() => {
    if (!permissionMessage) return;
    log.error('DiscoverAppDetails', "install permission returned error: ".concat(permissionMessage), {
      tags: {
        errorType: 'installPermissionError'
      },
      extraInfo: {
        appKey
      }
    });
    fireAnalyticsEvent({
      eventType: AppInstallPermissionEvaluationFailed,
      actionSubjectId: appKey,
      attributes: {
        error: permissionMessage
      }
    });
  }, [permissionMessage]);
  return hasInstallPermission;
};